module.exports = __webpack_public_path__ + "img/arrow.50edf507.png";